export const ROUTES = {
  NOT_FOUND: "*",
  ROOT: "/",
  LOGIN: "/login",
  PROFILE: "/profile",
  DASHBOARD: "/dashboard",
  ORDERS: "/orders",
  ORDER_ID: "/orders/:id",
  CREATE_ORDER: "/orders/create",
  EDIT_ORDER: "/orders/:id/edit",
  DRAFTS: "/drafts",
  EDIT_DRAFT: "/drafts/:id/edit",
  TRADING: "/trading",
  SOB_ORDERS: "/sob-orders",

  MODERATION_ORDERS: "/moderation-orders",
  MODERATION: "/moderation",
  NOTIFICATIONS: "/notifications",

  USER_MANAGEMENT: "/user-management",

  DIRECTORIES: "/directories",

  // MY_TRADES: "/my-trades",
  // TRADE_ID: "/trade/:id",
  // OFFERS_REVIEW: "/offers-review",
  // NOTIFICATION_SETTINGS: "/notification-settings",
  // CONTENT_MANAGEMENT: "/content-management",
  // REPORTS: "/reports",
  // NEWS: "/news",
} as const;
